// extracted by mini-css-extract-plugin
export default {"container":"Course_container__LNJhl","containerLeft":"Course_containerLeft__K04vz","containerRight":"Course_containerRight__2yYMY"};